// Каркас бара генерации — «виджета» (.gm): рамка, колонка содержимого и её ряды — загрузки (.gm__uploads),
// поле (.gm__prompt), нижний ряд с пилюлями и «Создать» (.gm__bottom), мобильный ряд (.gm__mobile-bar).
// Один каркас на бар /generate и главной (GenerateInputBar), док персонажей, локаций и предметов (PromptDock) и
// дальше композер «Сцены» (владелец 07.10: «переиспользовать компонент виджета под инструменты этой страницы»,
// а не копировать стили — иначе второй разметкой разъедутся, как когда-то главная и /generate).
// Каркас ничего не знает о модели и генерации: только разметка и классы; наполнение и логика — у страницы.
// Стили рядов — семейство .gm (styles/pages/generate/_modal.scss), страница добавляет только модификаторы.
import { forwardRef, type CSSProperties, type ReactNode, type Ref } from 'react'

function cls(base: string, extra?: string): string {
	return extra ? `${base} ${extra}` : base
}

/** Рамка бара и колонка содержимого: ряды идут детьми в нужном порядке. */
const BarShell = forwardRef<HTMLDivElement, { className?: string; style?: CSSProperties; children: ReactNode }>(
	function BarShell({ className, style, children }, ref) {
		return (
			<div className={cls('gm', className)} ref={ref} style={style}>
				<div className="gm__content">{children}</div>
			</div>
		)
	},
)
export default BarShell

/** Ряд загрузок: слоты картинок/видео слева, правый блок (чипы, карточка, сворачивание) — .gm__uploads-aside. */
export function BarUploads({ children, className, innerRef }: { children: ReactNode; className?: string; innerRef?: Ref<HTMLDivElement> }) {
	return <div className={cls('gm__uploads', className)} ref={innerRef}>{children}</div>
}

/** Поле текста (и всё, что живёт поверх него: меню «@», счётчики, гостевой оверлей). */
export function BarPrompt({ children, className }: { children: ReactNode; className?: string }) {
	return <div className={cls('gm__prompt', className)}>{children}</div>
}

/** Нижний ряд десктопа: пилюли слева (.gm__pills — у наполнения), «Создать» справа. На телефоне скрыт. */
export function BarBottom({ children, className }: { children: ReactNode; className?: string }) {
	return <div className={cls('gm__bottom', className)}>{children}</div>
}

/** Мобильный ряд: кнопки-иконки и «Создать» — виден только на телефоне (одна спека, два рендерера). */
export function BarMobileBar({ children, className }: { children: ReactNode; className?: string }) {
	return <div className={cls('gm__mobile-bar', className)}>{children}</div>
}
